export const enum WebsiteType {
    Ecommerce = "ecommerce",
    EcommerceDtc = "ecommerceDtc",
    EcommerceRetailer = "ecommerceRetailer",
    EcommerceOther = "ecommerceOther",
    Publisher = "publisher",
    Advertiser = "advertiser",
    Transactional = "transactional",
}

export const enum TopLevelDomainOption {
    EndsWith = "endsWith",
    Contains = "contains",
}

export const enum BusinessModel {
    B2B = "b2b",
    B2C = "b2c",
    Both = "b2b_b2c",
}

export const enum EmployeeHeadcount {
    Range_0_10 = "range_0_10",
    Range_10_50 = "range_10_50",
    Range_50_200 = "range_50_200",
    Range_200_500 = "range_200_500",
    Range_500_1000 = "range_500_1000",
    Range_1000_5000 = "range_1000_5000",
    Range_5000_10000 = "range_5000_10000",
    Range_10000_plus = "range_10000_plus",
}

export const enum AudienceAge {
    Age_group_18_24_share = "age_group_18_24_share",
    Age_group_25_34_share = "age_group_25_34_share",
    Age_group_35_44_share = "age_group_35_44_share",
    Age_group_45_54_share = "age_group_45_54_share",
    Age_group_55_64_share = "age_group_55_64_share",
    Age_group_65_share = "age_group_65_share",
}

export const enum AudienceGender {
    Female_80_100 = "female_80_100",
    Female_60_80 = "female_60_80",
    Female_40_60 = "female_40_60",
    Male_60_80 = "male_60_80",
    Male_80_100 = "male_80_100",
}

export const enum KeywordsTrafficSource {
    Organic = "organic",
    Paid = "paid",
    Both = "both",
}

export const enum AdChannel {
    Total = "total",
    Display = "display",
    Search = "search",
}
